module.exports = __webpack_public_path__ + "img/p4_img.76bcd49a.png";